import React from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import EntraIdRedirectComponent from './pages/EntraIdRedirect/EntraIdRedirectComponent';
import LoginContainer from './pages/Login/LoginContainer';
import Home from './pages/Home';
import DevHome from './pages/DevHome';
import { getCookie } from './utils/utils';
import PasswordReset from './pages/PasswordReset/PasswordResetForm/PasswordResetFormContainer';
import Search from './pages/Search';
import ProtectedRoute from './components/common/ProtectedRoute';
import FileViewer from './pages/FileViewer';
import RawFileViewer from './pages/RawFileViewer';
import LogoutComponent from './pages/Logout/LogoutComponent';
import LicenseComponent from './pages/License/LicenseComponent';
import Config from './components/Config/Config';

export default props => {
  const isLogged = getCookie('isLogged');

  return (
    <HashRouter>
      <Switch>
        <Route exact path="/entraid" component={EntraIdRedirectComponent} />
        <Route exact path="/login" component={LoginContainer} />
        <Route exact path="/logout" component={LogoutComponent} />
        <Route exact path="/license" component={LicenseComponent} />
        <Route exact path="/passwordreset" component={PasswordReset} />
        <ProtectedRoute path="/dev" component={DevHome} requireDevMode />
        <ProtectedRoute path="/home" component={Home} />
        <ProtectedRoute exact path="/search" component={Search} />
        <ProtectedRoute exact path="/config" component={Config} />
        <ProtectedRoute exact path="/documents/:id/file" component={FileViewer} />
        <ProtectedRoute exact path="/documents/:type/:id/rawfile" component={RawFileViewer} />
        <Route
          path="/"
          render={() => (isLogged ? <Redirect to="/search" /> : <Redirect to="/login" />)}
        />
        <Route path="/404" component={() => <div>404</div>} />
        <Redirect from="*" to="/404" />
      </Switch>
    </HashRouter>
  );
};
